<template>
    <div class="MainScreen">
        <TheNavbar @onExit="handleExit" />
        <Transition
            name="main-router"
            mode="out-in"
        >
            <RouterView />
        </Transition>
    </div>
</template>

<script>
import {
    mapActions,
} from 'vuex'
import { TheNavbar } from '@/components'

export default {
    name: 'MainScreen',
    components: {
        TheNavbar,
    },
    methods: {
        ...mapActions({
            signout: 'auth/signout',
        }),
        handleExit () {
            this.signout()
                .then(() => this.$router.push({ name: 'Signin' }))
        },
    },
}
</script>
<style scoped lang="scss">
.MainScreen {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: calc(100vh - #{$navbar-height});
    padding-top: $navbar-height;
}

.TheNavbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}
</style>
